export default __webpack_public_path__ + "static/media/task_launch_icon.a7e6f46a.svg";